export default "__VITE_ASSET__N2Wdh$x3__"